export class Estudiante {
  constructor(
    public nroLibreta: number,
    public apellido: string,
    public nombre: string,
    public fcNacimiento?: string,
    public documento?: string,
    public nacionalidad?: string,
    public ocupacion?: string,
    public domicilio?: string,
    public localidad?: string,
    public provincia?: string,
    public telefono?: string,
    public email?: string,
    public idInstructor?: number,
    public fcInicio?: string,
    public idCentroEntrenamiento?: number,
    public idGraduacionActual?: number,
    
    // ===== OPTIONAL FIELDS FROM SEARCH/FILTER =====
    public fcUltimoExamen?: string | null,  // ✅ Only present in filter results
    
    // ===== OPTIONAL RELATIONS (when included) =====
    public instructor?: { id: number; nombre: string; apellido: string } | null,
    public centroEntrenamiento?: { id: number; nombre: string; direccion: string } | null,
    public graduacionActual?: { id: number; nombre: string; abreviatura: string; corto: string; dan: number | null; gup: number | null } | null
  ) {}

  static fromRows(rows: any[]): Estudiante[] {
    return rows.map(row => Estudiante.fromApiData(row));
  }

  static fromApiData(data: any): Estudiante {
    return new Estudiante(
      data.nroLibreta || data.nro_libreta,
      data.apellido,
      data.nombre,
      data.fcNacimiento || data.fc_nacimiento,
      data.documento,
      data.nacionalidad,
      data.ocupacion,
      data.domicilio,
      data.localidad,
      data.provincia,
      data.telefono,
      data.email,
      data.idInstructor || data.id_instructor,
      data.fcInicio || data.fc_inicio,
      data.idCentroEntrenamiento || data.id_centro_entrenamiento,
      data.idGraduacionActual || data.id_graduacion_actual,
      data.fcUltimoExamen || data.fc_ultimo_examen || null,  // ✅ Extract if present
      data.instructor || null,
      data.centroEntrenamiento || data.centro_entrenamiento || null,
      data.graduacionActual || data.graduacion_actual || null
    );
  }

  fill(newFields: Partial<Estudiante>): void {
    for (let field in newFields) {
      if (this.hasOwnProperty(field) && newFields.hasOwnProperty(field)) {
        const key = field as keyof Estudiante;
        if (this[key] !== undefined) {
          (this[key] as any) = newFields[key]!;
        }
      }
    }
  }

  get nombreCompleto(): string {
    return `${this.nombre} ${this.apellido}`;
  }

  toJSON() {
    return {
      nroLibreta: this.nroLibreta,
      apellido: this.apellido,
      nombre: this.nombre,
      fcNacimiento: this.fcNacimiento,
      documento: this.documento,
      nacionalidad: this.nacionalidad,
      ocupacion: this.ocupacion,
      domicilio: this.domicilio,
      localidad: this.localidad,
      provincia: this.provincia,
      telefono: this.telefono,
      email: this.email,
      idInstructor: this.idInstructor,
      fcInicio: this.fcInicio,
      idCentroEntrenamiento: this.idCentroEntrenamiento,
      idGraduacionActual: this.idGraduacionActual
    };
  }
}